export default __webpack_public_path__ + "static/media/hdlogo.cc66dac7.png";